// import { useEffect, memo, useState } from "react";
// import { Outlet } from "react-router-dom";
// import { readHomePageService } from "services/globalService";
// import { STATE_ENTITIES } from "utils/entities";
// import { createApiThunk } from "store/thunks/apiThunks";
// import { createResetEntityApi } from "store/features/apiSlice";
// import { useSelector, useDispatch } from "react-redux";
// import { MatxSuspense } from "components";
// import { Fab, Zoom } from "@mui/material";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import { styled } from "@mui/material/styles";

// const StyledFab = styled(Fab)(({ theme }) => ({
//   position: 'fixed',
//   bottom: theme.spacing(4),
//   right: theme.spacing(4),
//   zIndex: 1000,
// }));

// const PublicGuard = () => {
//   const dispatch = useDispatch();
//   const [showScrollButton, setShowScrollButton] = useState(false);

//   const fetchHomepage = async () => {
//     try {
//       const dynamicThunk = createApiThunk(STATE_ENTITIES.GLOBAL.HOMEPAGE, readHomePageService, { page_name: "session" });
//       dispatch(dynamicThunk({ entity: STATE_ENTITIES.GLOBAL.HOMEPAGE }));
//     } catch (error) {
// //     }
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       setShowScrollButton(window.scrollY > 300);
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//       dispatch(createResetEntityApi(STATE_ENTITIES.GLOBAL.HOMEPAGE));
//     };
//   }, [dispatch]);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   return (
//     <MatxSuspense>
//       <Outlet />
//       <Zoom in={showScrollButton}>
//         <StyledFab
//           color="primary"
//           size="medium"
//           aria-label="scroll back to top"
//           onClick={scrollToTop}
//         >
//           <KeyboardArrowUpIcon />
//         </StyledFab>
//       </Zoom>
//     </MatxSuspense>
//   );
// };

// export default memo(PublicGuard);

import { useEffect, memo, useState, useRef } from "react";
import { Outlet } from "react-router-dom";
import { readHomePageService } from "services/globalService";
import { STATE_ENTITIES } from "utils/entities";
import { createApiThunk } from "store/thunks/apiThunks";
import { createResetEntityApi } from "store/features/apiSlice";
import { useSelector, useDispatch } from "react-redux";
import { MatxSuspense } from "components";
import { Fab, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { styled } from "@mui/material/styles";
import TawkToChat from "components/tawk/TawkToChat";

const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(8),
  right: theme.spacing(4),
  zIndex: 1000,
}));

const PublicGuard = () => {
  const dispatch = useDispatch();
  const [showScrollButton, setShowScrollButton] = useState(false);
  const scrollButtonRef = useRef(null);

  const fetchHomepage = async () => {
    try {
      const dynamicThunk = createApiThunk(STATE_ENTITIES.GLOBAL.HOMEPAGE, readHomePageService, { page_name: "session" });
      dispatch(dynamicThunk({ entity: STATE_ENTITIES.GLOBAL.HOMEPAGE }));
    } catch (error) {
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      dispatch(createResetEntityApi(STATE_ENTITIES.GLOBAL.HOMEPAGE));
    };
  }, [dispatch]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    if (scrollButtonRef.current) {
      if (showScrollButton) {
        scrollButtonRef.current.style.visibility = 'visible';
      } else {
        scrollButtonRef.current.style.visibility = 'hidden';
      }
    }
  }, [showScrollButton]);

  return (
    <MatxSuspense>
      <Outlet />
      <Zoom in={showScrollButton}>
        <StyledFab
          ref={scrollButtonRef}
          color="primary"
          size="medium"
          aria-label="scroll back to top"
          onClick={scrollToTop}
        >
          
          <KeyboardArrowUpIcon />
        </StyledFab>
      </Zoom>
      <TawkToChat />
    </MatxSuspense>
  );
};

export default memo(PublicGuard);